import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import QrCodeIcon from "@mui/icons-material/QrCode";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import api from "_api";
import { formatCurrency2Digit } from "utils/helpers/format";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen,
  handleModalPrint
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handlePrintQr = async (id) => {
    await api.product
      .getPrintQrCodeBuyProduct(id)
      .then((res) => {
        // console.log("res", res);
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handlePrintPDF = async (id) => {
    try {
      const response = await api.product.getGenerateAndPrintPdfBuyProduct(id);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
    } catch (error) {
      console.log("err", error);
    }
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
      showInFilter: false,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    {
      Header: "จำนวนประเภทสินค้า",
      accessor: "count_type_product",
      showInFilter: false,
    },
    {
      Header: "จำนวนทั้งหมด",
      accessor: "count_product_amount",
      showInFilter: false,
    },
    {
      Header: "ราคาทุน",
      accessor: "total_product_price",
      showInFilter: false,
      Cell: ({ row }) => {
        return (
          <span>{formatCurrency2Digit(row?.total_product_price || 0)}</span>
        );
      },
    },
    { Header: "วันที่ซื้อเข้า", accessor: "created_date", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          {/* {console.log("display row id", row)} */}
          <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeRowId === row.id}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                setViewProduct(row);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("row", row);
                setProduct(row);
                handleModalOpen();
                handleMenuClose();
              }}
            >
              <BorderColorIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>แก้ไข</span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                setProduct(row);
                // console.log("Delete product with ID:", row.original.id);
                // handleModalPrint();
                handlePrintPDF(row.id);
                handleMenuClose();
              }}
            >
              <LocalPrintshopIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>
                พิมพ์ใบรับซื้อสินค้า
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("Delete product with ID:", row.original.id);
                handlePrintQr(row.id);
              }}
            >
              <QrCode2Icon style={{ marginRight: "8px", color: "#737373" }} />
              <span style={{ marginLeft: "8px", color: "#737373" }}>
                พิมพ์ QR Code
              </span>
            </MenuItem>
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
